import '../style/yearpage.css';
import { useNavigate } from 'react-router-dom';
import CapeverdeImage from '../components/capeverde.gif';

function Year2016() {
    const navigate = useNavigate(); // Initialize the navigate function
  
    // Function to handle container clicks
    const handleContainerClick = (path) => {
      navigate(path); // Navigate to the specified path
    };

    const handleBackClick = () => {
      navigate('/'); // Navigate to the home page
    };
  
    return (
      <div className="year-page">
        <h1>2016 Photos</h1>
        <button 
        className="back-button" 
        onClick={handleBackClick}
      >
        ← Back
      </button>
        <div className="location-grid">
          {/* Cape Verde Location */}
          <div
            className="location-container"
            onClick={() => handleContainerClick('/capeverde')} // Redirect to /capeverde
            style={{ cursor: 'pointer' }} // Add pointer cursor to indicate clickability
          >
            <div
              className="image-container"
              style={{ backgroundImage: `url(${CapeverdeImage})` }}
            ></div>
            <p className="location-name">Cape Verde</p>
          </div>
        </div>
      </div>
    );
  }
  
  export default Year2016;


